import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    cursor: "pointer",
    display: "flex",
    color: "inherit",
    textDecorationLine: "none",
    flexDirection: "row",
    "@media (max-width: 500px)": {
      ...shorthands.gap("12px"),
      alignItems: "flex-start",
      minHeight: "90px",
    },

    ...shorthands.border("1px", "solid", tokens.colorNeutralBackground4),
    ...shorthands.borderRadius("4px"),
    ...shorthands.borderBottom("1px", "solid", tokens.colorNeutralBackground4),
    "@media (min-width: 0px) and (max-width: 499px)": {
      marginBottom: "14px",
      ...shorthands.borderRadius("8px"),
    },
    "@media (min-width: 500px) and (max-width: 555px)": {
      height: "130px",
      ...shorthands.overflow("auto"),
    },
    "@media (min-width: 556px)": {
      height: "110px",
    },
    justifyContent: "flex-start",
    alignItems: "center",
  },
  badge: {
    top: "-8px",
    right: "10px",
  },
  imageContainer: {
    width: "90px",
    height: "90px",
    "@media (min-width: 500px)": {
      height: "110px",
      width: "110px",
    },
  },
  image: {
    width: "90px",
    height: "90px",
    "@media (min-width: 500px)": {
      height: "110px",
      width: "110px",
    },
    flexShrink: 0,
    ...shorthands.border("1px", "transparent"),
    ...shorthands.borderRadius("4px"),
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px",
  },
  imageBorder: {
    width: "90px",
    height: "90px",
    ...shorthands.border("3px", "solid", "#5B41FF"),
    ...shorthands.borderRadius("4px"),
    "@media (min-width: 500px)": {
      height: "110px",
      width: "110px",
    },
  },
  body: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("2px"),
    alignItems: "flex-start",
    height: "100%",
    justifyContent: "center",
    flexGrow: 1,
    width: "100%",
    "@media (max-width: 500px)": {
      justifyContent: "flex-start",
      ...shorthands.padding("8px", "0"),
    },
    "@media (min-width: 500px)": {
      ...shorthands.padding("14px"),
    },
  },
  itemName: {
    display: "block",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    width: "100%",
    "@media (min-width: 500px)": {
      lineHeight: "16px",
      fontSize: tokens.fontSizeBase300,
    },
  },
  dietaryLabel: {
    color: tokens.colorNeutralForeground4,
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
  },
  description: {
    color: tokens.colorNeutralForeground4,
    ...shorthands.overflow("hidden"),
    fontSize: tokens.fontSizeBase200,
    "@media (min-width: 0px) and (max-width: 499px)": {
      width: "55vw",
    },
    "@media (min-width: 500px) and (max-width: 1899px)": {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 2,
      ...shorthands.overflow("hidden"),
      textOverflow: "ellipsis",
      height: "50px",
      whiteSpace: "break-spaces",
      width: "Calc(10vw - 2vw)",
    },
    "@media only screen and (min-width: 1900px)": {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 2,
      ...shorthands.overflow("hidden"),
      textOverflow: "ellipsis",
      height: "50px",
      whiteSpace: "break-spaces",
    },
  },
  price: {
    display: "flex",
    height: "28px",
    flexDirection: "row",
    ...shorthands.gap("2px"),
    justifyContent: "center",
    alignItems: "center",
  },
  calorieString: {
    color: tokens.colorNeutralForeground4,
    "@media (min-width: 0px) and (max-width: 499px)": {
      fontsize: tokens.fontSizeBase400,
    },

    "@media (min-width: 500px) and (max-width: 600px)": {
      fontSize: tokens.fontSizeBase200,
    },

    "@media (min-width: 601px)": {
      fontSize: tokens.fontSizeBase300,
    },
  },
  priceString: {
    "@media (min-width: 0px) and (max-width: 499px)": {
      fontsize: tokens.fontSizeBase400,
    },
    "@media (min-width: 500px) and (max-width: 600px)": {
      fontSize: tokens.fontSizeBase200,
    },

    "@media (min-width: 601px)": {
      fontSize: tokens.fontSizeBase300,
    },
  },
});
